// Deterministic avatar chip for any named actor (agent or human).
// Tint is derived from the name so the same actor always gets the same
// colour across sessions without any server configuration.

const TINTS = [
  'oklch(0.58 0.1 42)',   // clay
  'oklch(0.55 0.08 145)', // sage
  'oklch(0.52 0.07 220)', // slate
  'oklch(0.58 0.12 290)', // violet
  'oklch(0.56 0.1 190)',  // teal
  'oklch(0.54 0.11 60)',  // amber
];

function tintFor(name) {
  if (!name) return TINTS[0];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}

export function Avatar({ name, initials, urn, size = 28 }) {
  const displayInitials = initials
    || (name ? (name[0] + (name[1] || '')).toUpperCase() : '?');
  const style = {
    width: size,
    height: size,
    minWidth: size,
    fontSize: Math.round(size * 0.38),
    background: tintFor((name || urn || '').toLowerCase()),
    color: 'var(--paper)',
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    fontFamily: 'var(--ff-mono)',
    fontWeight: 600,
    letterSpacing: '0.02em',
    userSelect: 'none',
    flexShrink: 0,
  };
  return <span style={style} title={name || urn || ''}>{displayInitials}</span>;
}
